import React from 'react';

import { css } from '@emotion/react';
import VerifiedIcon from '@mui/icons-material/Verified';

import { palette } from '@styles/theme';

/** 조합 목록 HEADER */
export const GROUP_LIST_HEADER: any[] = [
  {
    value: 'no',
    label: 'No.',
  },
  {
    value: 'displayId',
    label: '조합ID',
  },
  {
    value: 'name',
    label: '조합명',
  },
  {
    value: 'type',
    label: '조합구분',
  },
  {
    value: 'period',
    label: '운용기간',
  },
  {
    value: 'contractAmount',
    label: '약정총액',
    textAlign: 'right',
  },
  {
    value: 'totalPayment',
    label: '납입총액',
    textAlign: 'right',
  },
  {
    value: 'portfolioCount',
    label: '투자기업 수',
  },
  {
    value: 'portfolioAmount',
    label: '투자금액',
    textAlign: 'right',
  },
];

/** 계정 정보 관리 > 목록 HEADER */
export const ACCOUNT_LIST_HEADER: any[] = [
  {
    value: 'no',
    label: 'No.',
    width: '100px',
  },
  {
    value: 'email',
    label: '이메일',
  },
  {
    value: 'name',
    label: '이름',
    width: '33%',
  },
  {
    value: 'delete',
    label: '',
    width: '200px',
  },
];

/** 기업보고자료 관리 > 목록 HEADER */
export const REPORT_LIST_HEADER: any[] = [
  {
    value: 'no',
    label: 'No.',
    width: '100px',
  },
  {
    value: 'year',
    label: '결산연도',
  },
  {
    value: 'periodType',
    label: '결산시기',
  },
  {
    value: 'name',
    label: '조합명',
  },
  {
    value: 'progress',
    label: '진행상태',
  },
  {
    value: 'requestDate',
    label: '등록일',
  },
  {
    value: 'deadline',
    label: '등록기한',
  },
];

/** 조합 관리 > 상세 > 포트폴리오사 목록 HEADER */
export const PORTFOLIO_LIST_HEADER: any[] = [
  {
    label: 'No.',
    value: 'no',
    width: '60px',
    isSorting: true,
  },
  {
    label: '기업명',
    value: 'name',
    width: '160px',
    isSorting: true,
  },
  {
    label: '서비스명',
    value: 'serviceName',
    width: '200px',
    isSorting: true,
  },
  {
    label: '최종투자일(납입기준)',
    value: 'lastInvestDate',
    width: '160px',
    isSorting: true,
  },
  {
    label: '총 투자횟수',
    value: 'totalInvestmentCount',
    width: '100px',
    isSorting: true,
  },
  {
    label: '보유주식수',
    value: 'shareholdingCount',
    textAlign: 'right',
    width: '180px',
    isSorting: true,
  },
  {
    label: '누적투자금액',
    value: 'totalInvestmentAmount',
    textAlign: 'right',
    width: '180px',
    isSorting: true,
    isSumColumn: true,
  },
  {
    label: '투자기업가치',
    value: 'corporateValue',
    textAlign: 'right',
    width: '180px',
    isSorting: true,
    isSumColumn: true,
  },
  {
    label: '마지막 기업가치',
    value: 'lastCorporateValue',
    textAlign: 'right',
    width: '180px',
    isSorting: true,
    isSumColumn: true,
  },
  {
    label: '누적발행수량',
    value: 'accumulatedIssuanceQuantity',
    textAlign: 'right',
    width: '180px',
    isSorting: true,
  },
  {
    label: '지분가치',
    value: 'equityValue',
    textAlign: 'right',
    width: '180px',
    isSorting: true,
    isSumColumn: true,
  },
  {
    label: '트래픽성장',
    value: 'traffic',
    textAlign: 'right',
    width: '100px',
    isSorting: true,
  },
  {
    label: '거래성장',
    value: 'sales',
    textAlign: 'right',
    width: '100px',
    isSorting: true,
  },
  {
    label: '고용성장',
    value: 'employee',
    textAlign: 'right',
    width: '100px',
    isSorting: true,
  },
  // {
  //   label: '런웨이',
  //   value: 'runway',
  //   isSorting: true,
  // },
];

/** 포트폴리오 상새 > 투자유치이력 > 투자이력 HEADER */
export const PORTFOLIO_DETAIL_INVEST_LIST_HEADER: any[] = [
  {
    label: '날짜',
    value: 'date',
    width: '200px',
  },
  {
    label: '투자단계',
    value: 'level',
  },
  {
    label: '투자유치금액',
    value: 'amount',
    textAlign: 'right',
  },
  {
    label: '투자사',
    value: 'investor',
    width: '50%',
  },
];

/** 포트폴리오 상세 > 자본금 변동내역 > 목록 HEADER */
export const PORTFOLIO_DETAIL_CAPITAL_CHANGE_LIST_HEADER: any[] = [
  {
    label: 'No.',
    value: 'no',
    width: '60px',
  },
  {
    label: '발행일자',
    value: 'issueDate',
    width: '100px',
  },
  {
    label: '유형',
    value: 'type',
  },
  {
    label: '거래구분',
    value: 'transactionType',
    width: '80px',
  },
  {
    label: '참가자명',
    value: 'name',
  },
  {
    label: '주식종류',
    value: 'stockType',
  },
  {
    label: '자본금',
    value: 'capital',
    textAlign: 'right',
  },
  {
    label: '액면가',
    value: 'faceValue',
    textAlign: 'right',
  },
  {
    label: '발행수량',
    value: 'issuanceQuantity',
    textAlign: 'right',
  },
  {
    label: '누적발행수량',
    value: 'accumulatedIssuanceQuantity',
    textAlign: 'right',
    width: '100px',
  },
  {
    label: '거래단가',
    value: 'sellingPrice',
    textAlign: 'right',
    width: '100px',
  },

  {
    label: '거래금액',
    value: 'transactionAmount',
    textAlign: 'right',
    width: '100px',
  },
  {
    label: '기업가치',
    value: 'enterpriseValue',
    textAlign: 'right',
    width: '100px',
  },
  {
    label: '',
    value: 'delete',
    width: '80px',
  },
];

/** 포트폴리오 상세 > 주요거래처 > 목록 HEADER */
export const PORTFOLIO_DETAIL_CUSTOMER_LIST_HEADER: any[] = [
  {
    label: '거래구분',
    value: 'type',
    width: '15%',
  },
  {
    label: '거래처명',
    value: 'name',
  },
  {
    label: '연간거래액',
    value: 'amount',
    width: '25%',
    textAlign: 'right',
  },
  {
    label: '거래비율',
    value: 'rate',
    width: '20%',
  },
];

/** 포트폴리오 상세 > 투자자산관리 > 투자자산 목록 HEADER */
export const PORTFOLIO_DETAIL_INVEST_ASSET_LIST_HEADER: any[] = [
  {
    label: 'No.',
    value: 'no',
    noWrap: true,
  },
  { label: '거래일자', value: 'date', noWrap: true, width: '110px' },
  { label: '거래구분', value: 'type', noWrap: true, width: '75px' },
  { label: '투자유형', value: 'investmentType', noWrap: true },
  { label: '거래당사자', value: 'counterparty', width: '120px' },
  { label: '거래금액', value: 'amount', textAlign: 'right', noWrap: true },
  {
    label: '거래후잔액',
    value: 'balanceAfter',
    textAlign: 'right',
    noWrap: true,
  },
  { label: '거래손익', value: 'profitLoss', textAlign: 'right', noWrap: true },
  { label: '거래주식수', value: 'shares', textAlign: 'right', noWrap: true },
  {
    label: '거래후보유주식수',
    value: 'sharesHeldAfter',
    textAlign: 'right',
    noWrap: true,
  },
  { label: '거래단가', value: 'unitPrice', textAlign: 'right', noWrap: true },
  { label: '액면가', value: 'parValue', textAlign: 'right', noWrap: true },
  {
    label: '거래전총발행주식수',
    value: 'totalIssuedSharesBefore',
    textAlign: 'right',
    noWrap: true,
  },
  {
    label: '거래후총발행주식수',
    value: 'totalIssuedSharesAfter',
    textAlign: 'right',
    noWrap: true,
  },
  {
    label: '지분율',
    value: 'ownershipRatio',
    textAlign: 'right',
    noWrap: true,
  },
  {
    label: '기업가치',
    value: 'enterpriseValue',
    textAlign: 'right',
    noWrap: true,
  },
  { label: '처리', value: 'action' },
];

/** 포트폴리오 상세 > 주주 현황 > 주주 현황 목록 HEADER */
export const PORTFOLIO_DETAIL_STOCKHOLDER_LIST_HEADER: any[] = [
  {
    label: 'No.',
    value: 'no',
    width: '100px',
  },
  {
    label: '주주명',
    value: 'name',
  },
  {
    label: '주식유형',
    value: 'stockType',
  },
  {
    label: '주식보유량',
    value: 'shareholding',
    isSumColumn: true,
    sortingField: 'shareholdingSort',
  },
  {
    label: '지분율',
    value: 'shareholdingRatio',
    isSumColumn: true,
    sortingField: 'shareholdingRatioSort',
    sumFormatter: (value: number) => value.toFixed(2) + '%',
  },
];

/** 포트폴리오 상세 > 사후관리 > 목록 HEADER */
export const POST_MANAGEMENT_LIST_HEADER: any[] = [
  {
    label: 'No.',
    value: 'no',
    width: '80px',
  },
  {
    label: '날짜',
    value: 'date',
    width: '140px',
  },
  {
    label: '구분',
    value: 'type',
    width: '100px',
  },
  {
    label: '작성내용',
    value: 'title',
  },
  {
    label: 'URL',
    value: 'urls',
    width: '400px',
    stopPropagation: true,
  },
];

/** 포트폴리오 상세 > 보도자료 > 목록 HEADER */
export const PRESS_LIST_HEADER: any[] = [
  {
    label: 'No.',
    value: 'no',
    width: '100px',
  },
  {
    label: '유형',
    value: 'type',
    width: '100px',
  },
  {
    label: '제목',
    value: 'title',
  },
  {
    label: '언론사',
    value: 'pressMedia',
    width: '200px',
  },
  {
    label: '보도일자',
    value: 'pressAt',
    width: '200px',
  },
];

const requiredStyle = css`
  position: absolute;
  top: 2px;
  margin-left: 3px;
  svg {
    fill: ${palette.colorGreen500};
    width: 13px;
    height: 13px;
  }
`;

/** 포트폴리오 상세 > 주주 현황 > 등록/수정하기 폼 HEADER */
export const PORTFOLIO_DETAIL_STOCKHOLDER_FORM_HEADER: any[] = [
  {
    label: (
      <div css={{ position: 'relative' }}>
        주주명
        <span css={requiredStyle}>
          <VerifiedIcon />
        </span>
      </div>
    ),
    value: 'name',
    textAlign: 'left',
  },
  {
    label: (
      <div css={{ position: 'relative' }}>
        주식유형
        <span css={requiredStyle}>
          <VerifiedIcon />
        </span>
      </div>
    ),
    value: 'stockType',
    // width: '300px',
    textAlign: 'left',
  },
  {
    label: (
      <div css={{ position: 'relative' }}>
        주식보유량
        <span css={requiredStyle}>
          <VerifiedIcon />
        </span>
      </div>
    ),
    value: 'issuanceQuantity',
    // width: '300px',
    textAlign: 'left',
  },
  {
    label: (
      <div css={{ position: 'relative' }}>
        지분율
        <span css={requiredStyle}>
          <VerifiedIcon />
        </span>
      </div>
    ),
    value: 'issuanceRate',
    // width: '300px',
  },
  {
    label: '삭제',
    value: 'delete',
    width: '140px',
    textAlign: 'left',
  },
];

/** 포트폴리오 상세 > 주주 현황 > 히스토리관리 목록 HEADER */
export const PORTFOLIO_DETAIL_STOCKHOLDER_HISTORY_HEADER: any[] = [
  {
    label: 'No.',
    value: 'no',
    width: '80px',
  },
  {
    label: '타이틀',
    value: 'title',
  },
  {
    label: '등록일',
    value: 'createdAt',
    width: '100px',
  },
  {
    label: '작성자 이메일',
    value: 'email',
  },
  {
    label: '불러오기',
    value: 'load',
    width: '100px',
  },
  {
    label: '파일',
    value: 'file',
    width: '100px',
  },
];

/** 마스터 계정 > 회사 관리 > 회사 목록 HEADER */
export const CLIENT_LIST_HEADER: any[] = [
  {
    label: 'No.',
    value: 'no',
    width: '80px',
  },
  {
    label: '회사ID',
    value: 'displayId',
  },
  {
    label: '회사명',
    value: 'name',
  },
  {
    label: '대표자명',
    value: 'ceo',
  },
  {
    label: '법인번호',
    value: 'corporateNo',
  },
  {
    label: '사업자번호',
    value: 'bizNo',
  },
  {
    label: '설립일',
    value: 'establishmentDate',
  },
  {
    label: '주소',
    value: 'address',
  },
  {
    label: '보유조합수',
    value: 'fundCount',
  },
];

/** 마스터 계정 > 회사 계정 관리 > 회사 목록 */
export const CLIENT_ACCOUNT_LIST_HEADER: any[] = [
  {
    value: 'no',
    label: 'No.',
    width: '80px',
  },
  {
    value: 'displayId',
    label: '회사ID',
    width: '150px',
  },
  {
    value: 'name',
    label: '회사명',
  },
  {
    value: 'ceo',
    label: '대표자명',
  },
  {
    value: 'corporateNo',
    label: '법인번호',
  },
  {
    value: 'bizNo',
    label: '사업자번호',
  },
];

/** 마스터 계정 > 회사 계정 관리 > 상세 > 회사 계정 목록 */
export const CLIENT_ACCOUNT_DETAIL_LIST_HEADER: any[] = [
  {
    value: 'no',
    label: 'No.',
    width: '100px',
  },
  {
    value: 'email',
    label: '이메일',
  },
  {
    value: 'delete',
    label: '',
    width: '100px',
  },
];

/** 기업보고자료 - 포트폴리오사 목록 HEADER */
export const REPORT_PORTFOLIO_LIST_HEADER: any[] = [
  {
    value: 'corpName',
    label: '기업명',
  },
  {
    value: 'investDate',
    label: '투자일',
  },
  {
    value: 'balanceSheet',
    label: '재무상태표',
  },
  {
    value: 'incomeStatement',
    label: '손익계산서',
  },
  {
    value: 'changesInEquity',
    label: '자본변동표',
  },
  {
    value: 'registerOfSocialInsurance',
    label: '4대보험 가입자명부',
  },
  {
    value: 'shareholderList',
    label: '주주명부',
  },
  {
    value: 'unissuedCertificate',
    label: '주권미발행확인서',
  },
  {
    value: 'yearylReport',
    label: '성과 및 계획',
  },
  {
    value: 'others',
    label: '기타',
  },
  {
    value: 'download',
    label: '일괄다운로드',
  },
  {
    value: 'status',
    label: '진행상태',
  },
  {
    value: 'lastModifiedAt',
    label: '최근수정일자',
  },
  {
    value: 'self',
    label: '결산자료 등록',
    width: '100px',
  },
];

/** 조합 관리 > 전체 포트폴리오사 목록 HEADER */
export const TOTAL_PORTFOLIO_LIST_HEADER: any[] = [
  {
    value: 'no',
    label: 'No.',
    width: '100px',
  },
  {
    value: 'portfolioName',
    label: '기업명',
    width: '300px',
  },
  {
    value: 'groupName',
    label: '조합명',
  },
  {
    value: 'totalInvestmentCount',
    label: '총 투자횟수',
    width: '160px',
  },
  {
    value: 'lastInvestDate',
    label: '최종투자일',
    width: '240px',
  },
  {
    value: 'totalInvestmentAmount',
    label: '누적투자금액',
    textAlign: 'right',
    width: '240px',
  },
];
